export const shareTargets = ['instagram','tiktok','facebook','x','messages','whatsapp','copy','save','more'];

/** Build from the resource URL, never from a visitor's campaign or auth query. */
export function shareActionUrl(base, target = 'more', kind = 'share') {
  const url = new URL(base);
  if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password) throw new Error('Invalid share URL');
  url.search = ''; url.hash = '';
  url.search = new URLSearchParams({ utm_source: 'musicmint_web', utm_medium: 'share', utm_campaign: kind === 'gift' ? 'gift_song' : 'song_share', utm_content: shareTargets.includes(target) ? target : 'more' }).toString();
  return url.href;
}

export function shareFailure(error, delivery_method) {
  return { delivery_method, result: error?.name === 'AbortError' ? 'dismissed' : delivery_method === 'clipboard' ? 'copy_failed' : 'error',
    error_stage: 'platform', error_code: error?.name === 'NotAllowedError' ? 'not_allowed' : 'unknown' };
}

/** One platform operation; callers keep their existing fallback and growth rules. */
export async function deliverShare({ navigator, method, url, title, text }) {
  if (method === 'manual') return { delivery_method: 'manual', result: 'copy_failed' };
  if (method === 'clipboard' && typeof navigator.clipboard?.writeText !== 'function') return { delivery_method: 'manual', result: 'copy_failed', error_stage: 'platform', error_code: 'unavailable' };
  try {
    if (method === 'web_share') await navigator.share(text ? { text } : { title, url });
    else await navigator.clipboard.writeText(url);
    return { delivery_method: method, result: method === 'web_share' ? 'system_sheet_returned' : 'copy_success' };
  } catch (error) { return shareFailure(error, method); }
}

export function audioErrorCode(error) {
  if (error?.name === 'NotAllowedError') return 'not_allowed';
  return ({ 1: 'media_aborted', 2: 'media_network', 3: 'media_decode', 4: 'media_src_not_supported' })[error?.code] || 'unknown';
}
